import React, { useState, useCallback, useEffect } from "react";
import LanguageItem from "../../steps/Language/LanguageItem";
import LanguageForm from "../../steps/Language/LanguageForm";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";

const CONFIRM_MODAL_ID = 'confirmModal';

function LanguageMainMenu({ curriculumVitae, handleSaveItem, handleDeleteItem, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [languages, setLanguages] = useState(curriculumVitae.curriculumVitaeLanguages || []);
    const [languageToDelete, setlanguageToDelete] = useState(null);
    const [editingLanguage, setEditingLanguage] = useState(null);
    const [addingLanguage, setAddingLanguage] = useState(false);

    useEffect(() => {
        setLanguages(curriculumVitae.curriculumVitaeLanguages || []);
    }, [curriculumVitae.curriculumVitaeLanguages]);

    const confirmDeleteLanguage = async (language) => {
        setlanguageToDelete(language);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    const handleSave = async (itemData, type) => {
        setAddingLanguage(false);
        handleSaveItem(itemData, type);
    }

    return (
        <div className="cv-main-menu-overview">
            {(editingLanguage || addingLanguage) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingLanguage ? 'Edit Mode' : 'Add Language'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                        <LanguageForm
                            curriculumVitaeId={curriculumVitae.id}
                            initialLanguage={editingLanguage}
                            setEditingLanguage={setEditingLanguage}
                            setAddingLanguage={setAddingLanguage}
                            onSave={(languageData) => handleSave(languageData, 'curriculumVitaeLanguages')}
                            status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="cv-main-menu-list">
                        <ul>
                            {curriculumVitae.curriculumVitaeLanguages.map((language) => (
                                <div key={language.id} className="main-menu-item-wrapper">
                                    <LanguageItem
                                        language={language}
                                        onEdit={() => setEditingLanguage(language)}
                                        onDelete={() => confirmDeleteLanguage(language.id)}
                                    />
                                </div>
                            ))}
                        </ul>
                    </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingLanguage(true)}>
                        <i className="pe-7s-plus mr-2"></i>
                        Add another language
                    </button>
                </>
            )}
            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this language?"
                message="This will permanently remove the selected language from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(languageToDelete, 'curriculumVitaeLanguages')}
            />
        </div>
    );
}

export default LanguageMainMenu;
